import React from 'react';
import { motion } from 'framer-motion';
import TimelineNode from './TimelineNode';
import { timelineData } from '../timelineData';
import { getTimelineIcon } from '../timelineIcons';

const VerticalTimeline = () => {
  return (
    <div className="relative">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand/5 via-transparent to-brand/5" />
      <div className="absolute left-1/2 top-0 bottom-0 w-4 -translate-x-1/2 bg-gradient-to-b from-brand/20 via-brand/10 to-brand/20 blur-xl" />

      {/* Timeline Content */}
      <div className="relative py-2 space-y-8">
        {timelineData.map((entry, index) => (
          <motion.div
            key={entry.year}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <TimelineNode
              year={entry.year}
              title={entry.title}
              description={entry.description}
              icon={getTimelineIcon(entry.title)}
              isBreakthrough={entry.isBreakthrough}
              index={index}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default VerticalTimeline;